import { render, staticRenderFns } from "./DecisionImage.vue?vue&type=template&id=7a6e31bc"
import script from "./DecisionImage.ts?vue&type=script&lang=ts&external"
export * from "./DecisionImage.ts?vue&type=script&lang=ts&external"
import style0 from "./Styles/decisionImage.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports